export const mapPageToProps = (id) => (state) => {
  const data =
    typeof state.autoLoaders.loaders[id] !== "undefined"
      ? state.autoLoaders.loaders[id]
      : {};
  
  const loadingList = state.autoLoaders.loadingList;
  const loading =
    typeof loadingList[id] !== "undefined" &&
    loadingList[id] === true;
  
  const autoSuggest =
    typeof state.autoLoaders.suggesters !== "undefined"
      ? state.autoLoaders.suggesters[id]
      : [];
  
  return {
    accessToken: state.currentUser.accessToken,
    myUser: state.currentUser.user,
    data,
    loading,
    autoSuggest,
  };
}
